<template>
    <div>
        <div class="clearfix margin-top-20" v-if="type == 'add'">
            <Form :label-width="140">
                <Col span="12">
                    <FormItem
                        :label="
                            $t('fbb.inventory.source_order', {
                                defaultValue: '来源单据',
                            })
                        "
                    >
                        <Select
                            v-model="sourceDeliver"
                            @on-change="reset"
                            style="width: 75%"
                        >
                            <Option value="0">{{
                                $t("erp.b2c.sale", { defaultValue: "销售" })
                            }}</Option>
                            <Option value="1">{{
                                $t("erp.b2c.after_sales", {
                                    defaultValue: "售后",
                                })
                            }}</Option>
                            <Option value="2">{{
                                    $t("uc.global_catelog.v2_shipping", {
                                        defaultValue: "运单",
                                    })
                                }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('fbb.expresspackage.search_for_packages', {
                                defaultValue: '搜索包裹',
                            })
                        "
                    >
                        <Input
                            v-model="deliverOrderNo"
                            style="width: 80%; float: left"
                            :placeholder="
                                sourceDeliver == 0
                                    ? $t(
                                          'fbb.expresspackage.logistics_tracking_shipping',
                                          {
                                              defaultValue:
                                                  '请输入物流单号或发货单号',
                                          }
                                      )
                                    : $t(
                                          'fbb.expresspackage.logistics_tracking_return',
                                          {
                                              defaultValue:
                                                  '请输入物流单号或退货单号',
                                          }
                                      )
                            "
                        >
                            <Button
                                slot="append"
                                icon="ios-search"
                                @click.native="findDeliverOrder"
                            ></Button>
                        </Input>
                    </FormItem>
                </Col>
            </Form>
        </div>
        <compWrapper
            :title="
                $t('global.common.base_information', {
                    defaultValue: '基本信息',
                })
            "
            theme="primary"
        >
            <div>
                <compFormQuery
                    v-if="type == 'query'"
                    :formdata="getBase"
                    :value="formData"
                    :labelWidth="120"
                    placeholder="--"
                ></compFormQuery>
                <compFormEdit
                    v-else
                    class="margin-15 clearfix"
                    ref="baseform"
                    :formdata="getBase"
                    v-model="formData"
                    :labelWidth="120"
                />
            </div>
            <div v-if="type !== 'query'" class="text-right">
                <vButton
                    class="margin-right-20"
                    theme="info"
                    @click="submit('0')"
                    >{{
                        $t("fbb.inbound.save_draft", {
                            defaultValue: "保存为草稿",
                        })
                    }}</vButton
                >
                <vButton
                    class="margin-right-20"
                    theme="primary"
                    @click="submit('1')"
                    >{{
                        $t("fbb.alloment.save_and_commit", {
                            defaultValue: "保存并提交",
                        })
                    }}</vButton
                >
                <vButton class="margin-right-20" @click="cancel">{{
                    $t("global.common.operate_cancel", { defaultValue: "取消" })
                }}</vButton>
            </div>
        </compWrapper>
        <compWrapper
            v-if="type === 'query'"
            :title="$t('', { defaultValue: '受理信息' })"
            theme="primary"
        >
            <div>
                <compFormQuery
                    :formdata="getBase1"
                    :value="formData"
                    :labelWidth="120"
                    placeholder="--"
                ></compFormQuery>
            </div>
        </compWrapper>
        <compWrapper
            :title="
                $t('global.common.operate_history', {
                    defaultValue: '操作历史',
                })
            "
            theme="gray"
            v-if="type === 'query'"
        >
            <compLog
                class="margin-layout"
                :data="logList"
                :columns="logcolumn"
            ></compLog>
        </compWrapper>

        <!-- 公共弹框 -->
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="closemodalprops"
        >
            <component
                ref="cusref"
                :is="modalProps.component"
                v-bind="modalProps"
                v-on="modalProps.on"
                @on-close="closemodalprops"
            ></component>
        </compModal>

        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
    HttpGetTrackingChangeDetail,
    HttpGetDeliverOrder,
    HttpSaveTrackingChange,
} from "@/service/expresspackage";
export default {
    props: ["activeids", "querytype"],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
    },
    data() {
        return {
            id: this.$route.query.id || this.activeids,
            type: this.$route.params.type || this.querytype,
            formData: {},
            loading: false,
            deliverOrderNo: "",
            sourceDeliver: "0",
            logList: [],
            modalProps: {},
        };
    },
    created() {
        this.update();
    },
    computed: {
        ...mapGetters("dictionary", []),
        getBase() {
            return [
                {
                    label: this.$t("fbb.inbound.logistics_singleno", {
                        defaultValue: "物流单号",
                    }),
                    key: "trackingNo",
                    props: {
                        readonly: this.type !== "add",
                    },
                },
                {
                    label: this.$t("global.common.source_number", {
                        defaultValue: "来源单号",
                    }),
                    key: "sourceNo",
                    props: {
                        readonly: this.type !== "add",
                        disabled: true,
                    },
                },
                {
                    label:
                        this.sourceDeliver == 0 || this.sourceDeliver == 2
                            ? this.$t("global.common.deliveryWarehouse", {
                                  defaultValue: "发货仓库",
                              })
                            : this.$t("fbb.alloment.receiveWarehouse", {
                                  defaultValue: "收货仓库",
                              }),
                    key: "orgWarehouseCode",
                    props: {
                        readonly: true,
                        disabled: true,
                    },
                },
                {
                    label:
                        this.sourceDeliver == 0 || this.sourceDeliver == 2
                            ? this.$t("erp.b2c.shipping_method", {
                                  defaultValue: "发货方式",
                              })
                            : this.$t("fbb.expresspackage.delivery_method", {
                                  defaultValue: "收货方式",
                              }),
                    key: "carrierServiceCode",
                    props: {
                        readonly: true,
                        disabled: true,
                    },
                },
                {
                    label:
                        this.sourceDeliver == 0 || this.sourceDeliver == 2
                            ? this.$t("fbb.expresspackage.recipient_name", {
                                  defaultValue: "收件人姓名",
                              })
                            : this.$t("fbb.expresspackage.sender_name", {
                                  defaultValue: "发件人姓名",
                              }),
                    key: "originalRecipientName",
                    props: {
                        readonly: true,
                        disabled: true,
                    },
                },
                {
                    label:
                        this.sourceDeliver == 0 || this.sourceDeliver == 2
                            ? this.$t("fbb.receiver.query", {
                                  defaultValue: "收货地址",
                              })
                            : this.$t("tms.ship.shipping_address", {
                                  defaultValue: "发货地址",
                              }),
                    key: "originalRecipientAddress",
                    props: {
                        readonly: true,
                        disabled: true,
                    },
                },
                {
                    label:
                        this.sourceDeliver == 0 || this.sourceDeliver == 2
                            ? this.$t("fbb.expresspackage.recipient_phone", {
                                  defaultValue: "收件人电话",
                              })
                            : this.$t("fbb.expresspackage.sender_phone", {
                                  defaultValue: "发件人电话",
                              }),
                    key: "originalRecipientPhone",
                    props: {
                        readonly: true,
                        disabled: true,
                    },
                },
                {
                    label: this.$t("fbb.expresspackage.process_type", {
                        defaultValue: "处理类型",
                    }),
                    key: "handleType",
                    tag: "vSelect",
                    show: this.sourceDeliver == 0 || this.sourceDeliver == 2,
                    options: [
                        {
                            value: 1,
                            label: this.$t("fbb.expresspackage.recall", {
                                defaultValue: "召回",
                            }),
                        },
                        {
                            value: 2,
                            label: this.$t(
                                "fbb.expresspackage.change_address",
                                {
                                    defaultValue: "更址",
                                }
                            ),
                        },
                        {
                            value: 3,
                            label: this.$t(
                                "fbb.expresspackage.abnormal_in_transit",
                                {
                                    defaultValue: "在途异常",
                                }
                            ),
                        },
                    ],
                },
                {
                    label: this.$t("fbb.expresspackage.process_type", {
                        defaultValue: "处理类型",
                    }),
                    key: "handleType",
                    tag: "vSelect",
                    show: this.sourceDeliver == 1,
                    options: [
                        {
                            value: 3,
                            label: this.$t(
                                "fbb.expresspackage.abnormal_in_transit",
                                {
                                    defaultValue: "在途异常",
                                }
                            ),
                        },
                    ],
                },
                {
                    label: this.$t("fbb.expresspackage.new_recipient_name", {
                        defaultValue: "新收件人姓名",
                    }),
                    key: "newRecipientName",
                    tag: "vInput",
                    show: this.formData.handleType === 2,
                },
                {
                    label: this.$t("fbb.expresspackage.new_shipping_address", {
                        defaultValue: "新收货地址",
                    }),
                    key: "newRecipientAddress",
                    tag: "vInput",
                    show: this.formData.handleType === 2,
                },
                {
                    label: this.$t("fbb.expresspackage.new_recipient_phone", {
                        defaultValue: "新收件人电话",
                    }),
                    key: "newRecipientPhone",
                    tag: "vInput",
                    show: this.formData.handleType === 2,
                },
                {
                    label: this.$t("global.common.notes", {
                        defaultValue: "备注",
                    }),
                    key: "customerRemark",
                    tag: "vTextarea",
                    required: false,
                },
            ];
        },
        getBase1() {
            return [
                {
                    label: this.$t("fbb.expresspackage.whether_accept", {
                        defaultValue: "是否受理",
                    }),
                    key: "carrierIsAcceptance",
                    render: (h) => {
                        return this.formData.carrierIsAcceptance === 1
                            ? this.$t("boss.purchase.correct", {
                                  defaultValue: "是",
                              })
                            : this.formData.carrierIsAcceptance === 2
                            ? this.$t("boss.purchase.deny", {
                                  defaultValue: "否",
                              })
                            : "--";
                    },
                },
                {
                    label: this.$t("", { defaultValue: "CASE ID" }),
                    key: "caseId",
                },
                {
                    label: this.$t("global.common.notes", {
                        defaultValue: "备注",
                    }),
                    key: "acceptanceRemark",
                },
            ];
        },
        logcolumn() {
            return [
                {
                    title: this.$t("global.common.operator", {
                        defaultValue: "操作人",
                    }),
                    key: "opUserName",
                },
                {
                    title: this.$t("global.common.operate_time", {
                        defaultValue: "操作时间",
                    }),
                    key: "opAt",
                },
                {
                    title: this.$t("global.common.notes", {
                        defaultValue: "备注",
                    }),
                    key: "opRemark",
                },
            ];
        },
    },
    methods: {
        reset() {
            this.formData = {};
        },
        update() {
            if (this.type == "add") return;
            HttpGetTrackingChangeDetail({
                id: this.id,
            }).then(
                (res) => {
                    this.logList = res.data.logEntities;
                    this.formData = res.data;
                    delete this.formData.logEntities;
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        findDeliverOrder() {
            HttpGetDeliverOrder({
                trackingNo: this.deliverOrderNo,
                orderType: this.sourceDeliver,
            }).then(
                (res) => {
                    this.formData = res.data;
                    const resTrackingNo = res.data.trackingNo.split(",");
                    if (resTrackingNo.length > 1) {
                        this.formData.trackingNo = "";
                        this.$VMessage.error({
                            content: this.$t(
                                "fbb.expresspackage.document_contains_a",
                                {
                                    defaultValue:
                                        "该单据有多个包裹，请手动输入物流单号",
                                }
                            ),
                            duration: 30,
                            closable: true,
                        });
                    }
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 1,
                        closable: true,
                    });
                }
            );
        },
        async submit(subtype) {
            let bool1 = await this.$refs.baseform.validate();
            if (!bool1) return;
            this.formData.orderStatus = subtype;
            this.loading = true;
            HttpSaveTrackingChange({
                ...this.formData,
            }).then(
                (res) => {
                    this.loading = false;
                    this.$VMessage.success(res.message);
                    this.cancel();
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        closemodalprops() {
            this.$emit("on-openCloseable");
            this.modalProps = {};
        },
        cancel() {
            this.$router.push({
                name: "delivertRecall",
            });
        },
    },
};
</script>
